import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default (scroller) => {
    if(document.getElementById('portalPage')){

      scroller.on("scroll", ScrollTrigger.update);

      ScrollTrigger.scrollerProxy(".smooth-scroll", {
        scrollTop(value) {
          return arguments.length ? scroller.scrollTo(value, 0, 0) : scroller.scroll.instance.scroll.y;
        }, 
        getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
        },
        pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
      });
  
  
      ScrollTrigger.addEventListener("refresh", () => scroller.update());
      ScrollTrigger.refresh(); 
  
      let fadeInContainer = document.querySelectorAll('.portalSection');
  
        fadeInContainer.forEach(fadeInContainer => {
        let fadeInElem = gsap.utils.toArray(fadeInContainer.querySelectorAll('.reportContainer'));
  
        fadeInElem.forEach(elem => {
  
          gsap.to('#HeaderAnchors', {
            scrollTrigger: {
              trigger: fadeInContainer,
              scroller: '.smooth-scroll',
              start: "top 100%",
              end: "bottom 100%",
              toggleActions: "play none reverse none",
              onEnter: () => {
                console.log('Entered!!')
                document.getElementById('HeaderAnchors').classList.add('hideNav');
                let styles = window.getComputedStyle(elem);
                const duration = parseFloat(styles.transitionDuration);
                const delay = parseFloat(styles.transitionDelay);
  
                setTimeout(() => {
                  document.getElementById('HeaderAnchors').classList.add('hideNav');
                }, (duration + delay) * 1000);
              },
              onEnterBack:() => {
                console.log('Left!');
                document.getElementById('HeaderAnchors').classList.remove('hideNav');
                let styles = window.getComputedStyle(elem);
                const duration = parseFloat(styles.transitionDuration);
                const delay = parseFloat(styles.transitionDelay);
  
                setTimeout(() => {
                  document.getElementById('HeaderAnchors').classList.remove('hideNav');
                }, (duration + delay) * 1000);

              }
            }
          });
        });
      });


    }

  }